import axios from "axios"
import HandleFail from "../../utils/error_handler"
import feature_schema from "../../configs/feature_schema.json"

const get_relevant_feature = (features, layer_id) => {
  if (!features) {
    return null
  }
  return features.find((feature) => {
    return feature.layer.id === layer_id
  })
}

const handle_distance_query = async (
  id,
  distance_query,
  set_distance_query,
) => {
  let updated_distance_query = { ...distance_query }
  if (
    updated_distance_query.last_updated === null ||
    updated_distance_query.last_updated === "to"
  ) {
    updated_distance_query.last_updated = "from"
    updated_distance_query.from = id
  } else {
    updated_distance_query.last_updated = "to"
    updated_distance_query.to = id
  }
  const { from, to } = updated_distance_query
  if (from && to) {
    let {
      data: { distance },
    } = await axios.get(
      `/api/data/od/${updated_distance_query.from}/${updated_distance_query.to}`,
    )
    if (typeof distance !== "number") {
      distance = parseFloat(distance)
    }
    updated_distance_query.distance = distance
  }
  set_distance_query(updated_distance_query)
}

export default function handleClick({
  click,
  measure_mode,
  distance_query,
  set_distance_query,
}) {
  HandleFail(async () => {
    const { features } = click
    if (features.length === 0) {
      return
    } else if (measure_mode === true) {
      const au = get_relevant_feature(features, "analysis_units_shaded")
      const id = au.properties[feature_schema.au.id_property]
      handle_distance_query(id, distance_query, set_distance_query)
    }
  })
}
